import { updatesItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            实时追踪娱乐圈最新动态，一手消息即时呈现
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300">
            {updatesItems.map((item, i) => (
              <div key={i} className={`relative pb-8 ${i === updatesItems.length - 1 ? 'pb-0' : ''}`}>
                <div className={`absolute -left-[25px] top-0.5 w-3 h-3 rounded-full border-2 border-background-50 ${item.hot ? 'bg-primary-500' : 'bg-secondary-400'}`}></div>
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-400 font-medium">{item.time}</span>
                  <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${item.hot ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-600'}`}>
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="text-[10px] text-primary-500 font-semibold">HOT</span>
                  )}
                </div>
                <p className="text-sm font-medium text-foreground-800 leading-relaxed">
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}